function closeDropMenus(evt) {
	if (evt) { evt.stopPropagation(); }
	if ($(evt.target).closest('.dropbutton').length === 0 && $(evt.target).hasClass('dropbutton') === false) {
		const myEvent = new CustomEvent('closeAllDropMenus', {});
		window.dispatchEvent(myEvent);
	}
}
							
class Podcast {
	
	static createComponents() {
		Vue.component('podcast-episode', {
			props: {
				episode: Object
			}, 
			data: function() {
				return {
					listen_active: false
				};
			}, 
			computed: {
				picURL: function() {
					if ((typeof this.episode.logo_override) == 'string' && this.episode.logo_override.length > 0) {
						return window.BASE_URL + 'images/podcasts/' + this.episode.logo_override;
					}
					return window.BASE_URL + 'images/podcast-badge-1.png';
				}, 
				hasEpisodeNum: function() {
					return ((typeof this.episode.episode_num) == 'string' && this.episode.episode_num.length > 0);
				}, 
				displayDate: function() {
					var d = DateTime.fromISO(this.episode.pubdate);
					return d.toLocaleString({ month: 'long', year: 'numeric' });
				}, 
				displayDateFull: function() {
					var d = DateTime.fromISO(this.episode.pubdate);
					return d.toLocaleString(DateTime.DATE_FULL); // month, day, year
				}, 
				duration: function() {
					let out = '';
					if (this.episode.duration_hours.length > 0) { out += this.episode.duration_hours + ' hr. '; }
					if (this.episode.duration_minutes.length > 0) { out += this.episode.duration_minutes + ' min.'; }
					return out;
				}, 
				isPinned: function() { return parseInt(this.episode.pinned) == 1; }, 
				hasSpotify: function() { return window.isBlank(this.episode.spotify_url) === false; }, 
				hasiTunes: function() { return window.isBlank(this.episode.itunes_url) === false; }, 
				hasAnchor: function() { return window.isBlank(this.episode.anchor_url) === false; }, 
				hasGoogle: function() { return window.isBlank(this.episode.google_url) === false; } 
			}, 
			methods: {
				toggleListenMenu: function() {
					this.listen_active = (this.listen_active === false);
					if (this.listen_active === true) {
						if (is.existy(window.AK.dropMenuListenerExists) === false || window.AK.dropMenuListenerExists !== true) {
							window.AK.dropMenuListenerExists = true;
							$('body').on('click', '*', closeDropMenus);
						}
					}
				}, 
				listenLinkClicked: function(evt) {
					if (evt) { evt.stopPropagation(); }
					try {
						window.lintrk('track', { conversion_id: 6654738 }); // LinkedIn conversion tracking
					} catch (err) {} // Don't derail if the tracking function is unavailable.
					this.closeListenMenu(evt);
				}, 
				closeListenMenu: function(evt) {
					if (evt) { evt.stopPropagation(); }
					this.listen_active = false;
					$('body').off('click', '*', closeDropMenus);
					window.AK.dropMenuListenerExists = false;
					return true;
				}
			}, 
			mounted: function() {
				window.addEventListener('closeAllDropMenus', this.closeListenMenu);
			}, 
			template: `<div class="podcast-episode" :id="'podcastEpisode-' + this.episode.id">
				<div class="row">
					<div class="small-3 medium-4 large-3 columns episodePhotoCol">
						<img :src="picURL" alt="">
					</div>
					<div class="small-9 medium-8 large-9 columns episodeTextCol">
						<div class="podcast-pinnedrow" v-if="isPinned"><i class="fa-solid fa-thumbtack"></i> Pinned Episode</div>
						<div class="podcast-daterow">
							<span class="episode-date">{{ displayDate }}</span>
						</div>
						<h2>{{ episode.title }}</h2>
						<div class="episode-description" v-html="episode.description"></div>
						<div class="episode-stats">
							<span class="episode-duration">{{ duration }}</span>
							<div class="dropbutton">
								<button class="dropbutton-toggle" v-on:click.prevent="toggleListenMenu()">Listen <i class="fas fa-caret-down"></i></button>
								<div class="dropbutton-menu" v-bind:class="{ 'active': listen_active === true }">
									<a v-if="hasSpotify" :href="episode.spotify_url" v-on:click="listenLinkClicked()" target="_blank" class="podcastListenLink" data-listenType="spotify">Listen on Spotify</a>
									<a v-if="hasiTunes" :href="episode.itunes_url" v-on:click="listenLinkClicked()" target="_blank" class="podcastListenLink" data-listenType="itunes">Listen on Apple Podcasts</a>
									<a v-if="hasGoogle" :href="episode.google_url" v-on:click="listenLinkClicked()" target="_blank" class="podcastListenLink" data-listenType="google">Listen on Google Podcasts</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>`
		});

	}
}